export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20of%20diverse%20curated%20fashion%20and%20lifestyle%20products%20including%20sneakers%20denim%20jackets%20sunglasses%20bags%20and%20accessories%20scattered%20artistically%20on%20textured%20charcoal%20grey%20linen%20fabric%2C%20dramatic%20top%20down%20lighting%20with%20deep%20shadows%2C%20high%20contrast%20editorial%20product%20photography%2C%20dark%20sophisticated%20moody%20aesthetic%2C%20rich%20varied%20textures%20and%20materials%2C%20no%20text%20no%20logos%20no%20faces&width=1800&height=1200&seq=hero-main-v2-001&orientation=landscape"
          alt="AllChinaBuy Spreadsheet product curation background"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/28 to-black/45"></div>
      </div>

      {/* Content */}
      <div className="relative w-full px-6 md:px-10 py-32 md:py-40">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
            {/* Left Content */}
            <div className="flex-1 text-center lg:text-left">
              <p className="text-primary-300 text-sm md:text-base font-medium tracking-widest uppercase mb-4">
                Updated June 2026
              </p>
              <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-white leading-tight mb-6">
                Best AllChinaBuy<br />
                Spreadsheet{' '}
                <span className="italic font-normal text-primary-300">2026 Edition</span>
              </h1>
              <p className="text-white/80 text-base md:text-lg max-w-xl mx-auto lg:mx-0 mb-10 leading-relaxed">
                Discover the latest AllChinaBuy Spreadsheet with verified finds, quality checks, shipping guides and community recommendations — updated weekly.
              </p>
              <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
                <a
                  href="https://kaspreadsheet.com/"
                  target="_blank"
                  rel="noopener nofollow"
                  className="group bg-white text-foreground-900 text-sm md:text-base font-semibold px-8 py-3.5 rounded-md hover:bg-white/90 transition-all flex items-center gap-2 whitespace-nowrap cursor-pointer w-full sm:w-auto justify-center"
                >
                  AllChinaBuy Spreadsheet
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                </a>
                <a
                  href="https://kaspreadsheet.com/"
                  target="_blank"
                  rel="noopener nofollow"
                  className="group border-2 border-white/60 text-white text-sm md:text-base font-semibold px-8 py-3.5 rounded-md hover:bg-white/10 hover:border-white transition-all flex items-center gap-2 whitespace-nowrap cursor-pointer w-full sm:w-auto justify-center"
                >
                  Buy It Now
                  <i className="ri-shopping-cart-line group-hover:translate-x-1 transition-transform"></i>
                </a>
              </div>
            </div>

            {/* Right Visual - Decorative */}
            <div className="hidden lg:flex flex-1 justify-center">
              <div className="relative w-80 h-80 xl:w-96 xl:h-96 rounded-2xl overflow-hidden bg-background-50/10 backdrop-blur-sm border border-white/10">
                <img
                  src="https://readdy.ai/api/search-image?query=Artistic%20arrangement%20of%20premium%20sneakers%20leather%20wallet%20designer%20sunglasses%20and%20silk%20scarf%20on%20dark%20slate%20stone%20surface%2C%20dramatic%20side%20lighting%20from%20upper%20left%20corner%2C%20luxury%20editorial%20product%20photography%2C%20sophisticated%20moody%20atmosphere%2C%20rich%20deep%20shadows%20and%20highlights%2C%20jewel%20tone%20accents%20of%20emerald%20and%20amber%2C%20no%20text%20no%20logos%20no%20faces&width=800&height=800&seq=hero-side-v2-002&orientation=squarish"
                  alt="Curated AllChinaBuy finds"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>
          </div>

          {/* Scroll indicator */}
          <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/50">
            <span className="text-xs tracking-widest uppercase">Scroll</span>
            <i className="ri-arrow-down-line animate-bounce"></i>
          </div>
        </div>
      </div>
    </section>
  );
}